import { Injectable } from '@angular/core';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { FormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

/**
 * Command service for controlling availability and value of
 * an OrderAdjustment checkbox for RMX Colombia
 */
@Injectable()
export class AdjustmentCheckboxCommandCO implements OnFieldChanged {
  private minAvailableQty = 20;

  onFieldChanged(
    value: any,
    formGroup: FormGroup,
    form: ConfigurableFormComponent | null,
    config?: FieldConfig,
    prev?: any,
  ) {
    const adjustmentCheckbox = formGroup.get(SpecFieldNames.ADJUSTMENT);
    if (value < this.minAvailableQty) {
      adjustmentCheckbox.patchValue(false);
      adjustmentCheckbox.disable();
    } else {
      adjustmentCheckbox.enable();
    }
  }
}
